import { Link } from "react-router-dom";
import { PORTFOLIO_URL } from "../../seoConfig";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__copy">
          © 2026{" "}
          <Link to="/" className="site-footer__brand">
            StayHealthy
          </Link>
          <span className="site-footer__sep">·</span>
          Built by{" "}
          <a
            href={PORTFOLIO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer__author"
          >
            Amina Javed
          </a>
          <span className="site-footer__sep">·</span>
          All rights reserved
        </p>
      </div>
    </footer>
  );
}
